import { Extension } from '@tiptap/core';

import { BlockMath, BlockMathHeadless, InlineMath, InlineMathHeadless } from './extensions/index';
import { MathEditing } from './math-editing-extension';
import type { MathematicsOptions } from './types';

export const MathematicsHeadless = Extension.create<MathematicsOptions>({
    name: 'Mathematics',

    addOptions() {
        return {
            renderer: 'mathjax',
            inlineOptions: undefined,
            blockOptions: undefined,
            katexOptions: undefined,
        };
    },

    addExtensions() {
        return [
            BlockMathHeadless.configure({
                ...this.options.blockOptions,
                renderer: this.options.renderer,
                katexOptions: this.options.katexOptions,
            }),
            InlineMathHeadless.configure({
                ...this.options.inlineOptions,
                renderer: this.options.renderer,
                katexOptions: this.options.katexOptions,
            }),
            MathEditing,
        ];
    },
});

export const Mathematics = MathematicsHeadless.extend({
    addExtensions() {
        return [
            BlockMath.configure({
                ...this.options.blockOptions,
                renderer: this.options.renderer,
                katexOptions: this.options.katexOptions,
            }),
            InlineMath.configure({
                ...this.options.inlineOptions,
                renderer: this.options.renderer,
                katexOptions: this.options.katexOptions,
            }),
            MathEditing,
        ];
    },
});

export default Mathematics;
